<script setup lang="ts">
import ActiviteCommercialInfoCard from '@/components/activite-commercial/ActiviteCommercialInfoCard.vue'
import ActiviteCommercialTable from '@/components/activite-commercial/ActiviteCommercialTable.vue'
import DraggableContainer from '@/components/ui/draggable/DraggableContainer.vue'
import { useComponentOrder } from '@/lib/useComponentOrder'
import { markRaw } from 'vue'

const defaultComponents = [
  {
    id: 'repartition-card',
    component: markRaw(ActiviteCommercialInfoCard),
  },
  {
    id: 'repartition-table',
    component: markRaw(ActiviteCommercialTable),
  },
]

const { components } = useComponentOrder('activite-commercial-page', defaultComponents)
</script>

<template>
  <DraggableContainer v-model:components="components" />
</template>
